/**
 * /frontend/src/features/analytics/components/whatif/CurrentVsProjectedChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import GroupedBarChart from '../charts/GroupedBarChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Current vs projected metrics comparison.
 * @param {{title:string,data:Array<{metric:string,current:number,projected:number}>}} props
 * @returns {JSX.Element}
 */
const CurrentVsProjectedChart = ({ title, data }) => {
  const bars = useMemo(() => ([
    { key: 'current', label: 'Current', color: CHART_COLORS.accentStrong },
    { key: 'projected', label: 'Projected', color: CHART_COLORS.accent }
  ]), []);

  return (
    <ChartContainer title={title} subtitle="Projected values update as you change inputs">
      <GroupedBarChart data={data} xKey="metric" bars={bars} />
    </ChartContainer>
  );
};

export default CurrentVsProjectedChart;

